export default "__VITE_ASSET__DDTsvnKV__"